module.exports = __webpack_public_path__ + "static/media/sqlserver_manager_network_protocol_tab.8845ffe6.png";